export default __webpack_public_path__ + "static/media/beacon_watch_icon.7705b38d.png";